// BCM-898 · Goods Receipt Dashboard — "View Consumption Document" tab body.
// Renders GRDigitalizedDocumentReview (the real CommonDigitizedDocument, embedded
// — no Dialog, no product-details ribbon) scoped to the consumption document —
// no longer ViewRmPMLots, so it matches the PPT mockup and no longer brings the
// bottom-right comment FAB. Used by the second tab of PA4/PA6 (and the produced-qty
// document tab, slide 21). CommonDigitizedDocument itself decides Mark Review as
// Complete vs. Update & Re-run from the document's own reviewed state.
import React from "react";
import GRDigitalizedDocumentReview from "./GRDigitalizedDocumentReview";

const ConsumptionDocumentTab = ({ row, detail, onRefresh, viewOnly }) => (
  <GRDigitalizedDocumentReview
    row={row}
    detail={detail}
    onRefresh={onRefresh}
    onlyConsumption
    viewOnly={viewOnly}
  />
);

export default ConsumptionDocumentTab;
